import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { getBudgetDetailsHistoryFormatedDate } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/utils/helpers/getBudgetDetailsHistoryFormatedDate";
import { resourceExplorerDataByViewIdSelector } from "@/store/budgets/selectors/current-budget/chart/resourceExplorerDataByViewIdSelector";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { currentBudgetPeriodSelector } from "@/store/budgets/selectors/current-budget/data-selectors/currentBudgetPeriodSelector";

type TotalizedData = {
  formatedDate: string;
  total: number;
  date: string;
};

export const budgetChartSummarizedDataSelector = createDraftSafeSelector(
  [
    resourceExplorerDataByViewIdSelector,
    currentBudgetPeriodSelector,
    organisationQuarterStartMonthSelector,
  ],
  (resourceExplorerData, period, quarterStartMonth) => {
    const data = resourceExplorerData?.data?.data;

    let totals: TotalizedData[] | undefined = data?.map(({ items, value }) => {
      const total =
        items?.reduce((sum, item) => sum + (item?.cost || 0), 0) ?? 0;

      return {
        formatedDate: getBudgetDetailsHistoryFormatedDate(
          value,
          period,
          quarterStartMonth,
        ),
        total,
        date: value ?? "",
      };
    });

    // Sum repeated dates
    if (period === "annually" || period === "quarterly") {
      totals = totals?.reduce(
        (acc, curr) => {
          const last = acc[acc.length - 1];
          if (last && compareCurrentAndLastQuartersWithoutYears(last, curr)) {
            last.total += curr?.total ?? 0;
          } else {
            acc.push(curr);
          }
          return acc;
        },
        [] as { formatedDate: string; total: number; date: string }[],
      );
    }

    return totals;
  },
);

// Same quarter can start in one year and end in another, so we need to compare current and last quarters without years
const compareCurrentAndLastQuartersWithoutYears = (
  last: TotalizedData,
  curr: TotalizedData,
) => {
  return (
    last.formatedDate.split(" ").at(0) === curr.formatedDate.split(" ").at(0)
  );
};
